import { styled } from '@mui/material/styles';

export const DropRoot = styled('div', {
  shouldForwardProp: (prop) => !['isDragActive', 'isDisabled'].includes(prop),
})(({ theme, isDragActive, isDisabled }) => ({
  position: 'relative',
  border: `2px dashed ${isDragActive ? theme.palette.primary.main : theme.palette.divider}`,
  borderRadius: 4,
  padding: theme.spacing(3),
  textAlign: 'center',
  backgroundColor: isDragActive ? theme.palette.action.hover : 'transparent',
  cursor: isDisabled ? 'default' : 'pointer',
  transition: 'background-color 150ms, border-color 150ms',
  outline: 'none',
}));

export const DropText = styled('p')(({ theme }) => ({
  margin: 0,
  marginTop: theme.spacing(1),
  color: theme.palette.text.secondary,
  fontSize: '1rem',
}));

export const PreviewGrid = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
  justifyContent: 'center',
}));

export const PreviewThumb = styled('div')({
  width: 80,
  height: 80,
  borderRadius: 4,
  overflow: 'hidden',
  position: 'relative',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
});
